import { isPlainObject } from 'lodash'

import { projectName } from './constants/misc'

/**
 * Возвращает ключ localStorage сохранённой сортировки списка сервиса.
 *
 * @param {string} service Имя сервиса через точку, например `country-regions`.
 * @returns {string} Ключ вида `sigma:<service>:order`.
 */
export const getOrderStorageKey = service => {
  return [ projectName, service, 'order' ].filter(Boolean).join(':')
}

/**
 * Возвращает сохранённую в localStorage сортировку списка сервиса.
 * Отсутствующее, испорченное или не являющееся объектом значение не возвращается.
 *
 * @param {string} service Имя сервиса через точку, например `country-regions`.
 * @returns {{ orderField: string, orderDirection: string }|undefined} Сохранённая сортировка.
 */
export const getStoredOrder = service => {
  try {
    const order = JSON.parse(window.localStorage.getItem(getOrderStorageKey(service)))
    if (isPlainObject(order)) {
      return order
    }
  } catch (error) {
  }
}
